import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const deleteService = async (placeId, serviceId) => {
  if (!placeId || !serviceId) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.delete({
    path: `${uri.api}/place/${placeId}/services/${serviceId}/delete`,
  });
};